import { CRUD } from "@/shared/components";
import { DisputesListQuery } from "@/admin/entities/disputes";
import {
  useDisputesManagement,
  type DisputeRow,
  DisputesSchemas,
} from "../model";

/**
 * Реестр диспутов. Только просмотр — редактирования, создания и
 * удаления нет.
 */
export function Disputes() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    useDisputesManagement();

  return (
    <CRUD<DisputeRow>
      listQuery={DisputesListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={DisputesSchemas.filterSchema}
      texts={texts}
      persistFilters
      hideCreateButton
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
